function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCounter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M703.75,271S645.31,108.36,499.94,59.27,273.65,21.68,208.46,84.58,120,245.68,71.34,297.84s-76.43,125,107.9,163.39,223.29-27.61,350.67-13.8S741.22,412.14,703.75,271Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.75,271S645.31,108.36,499.94,59.27,273.65,21.68,208.46,84.58,120,245.68,71.34,297.84s-76.43,125,107.9,163.39,223.29-27.61,350.67-13.8S741.22,412.14,703.75,271Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M650.1,386.06c1.2,1,4.58,1.92,4.59,1.92s-.08-2.41-.1-2.56c-.28-1.77-1.86-5-3.84-5.31a2.37,2.37,0,0,0-2.66,2.31A5,5,0,0,0,650.1,386.06Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.38,396.14a16.51,16.51,0,0,0,4.89.65,40.82,40.82,0,0,0,.33,5.58c.13,1.07.3,2.16.47,3.24-.15-.48-.29-.91-.32-1-.74-1.63-3.12-4.33-5.1-4.1a2.36,2.36,0,0,0-2,2.92,4.91,4.91,0,0,0,2.9,3,15.64,15.64,0,0,0,4.74.65c.08.41.14.83.22,1.24.36,2,.72,4,1,5.93.11.68.19,1.37.27,2.05-.14-.43-.26-.79-.29-.84-.73-1.63-3.11-4.33-5.1-4.1a2.35,2.35,0,0,0-2,2.92,4.9,4.9,0,0,0,2.89,3,15.35,15.35,0,0,0,4.61.65c.07.7.13,1.4.16,2.08,0,.47.05.92,0,1.39s0,.92,0,1.38c0,.87-.09,1.78-.15,2.63,0,.6-.09,1.16-.14,1.73-.1-.69-.32-2-.35-2.14-.48-1.71-2.42-4.75-4.42-4.82a2.36,2.36,0,0,0-2.38,2.59,4.94,4.94,0,0,0,2.42,3.39,16.09,16.09,0,0,0,4.7,1.37c-.09.94-.18,1.86-.28,2.72q-.09.78-.18,1.5h1.22c0-.45.1-.9.14-1.37.09-1,.17-2,.23-3a24.49,24.49,0,0,0,3-.46,17.28,17.28,0,0,0,3.09,3.59l-1,1.28h1.46c.21-.27.42-.53.62-.81.16.09.83.44,1.65.81h6.59a2.2,2.2,0,0,0,.31-.3,2.37,2.37,0,0,0-.32-3.5c-1.64-1.15-5,.09-6.45,1.17-.08.06-.91.85-1.43,1.36l.78-1c.52-.71,1-1.43,1.56-2.2l.76-1.15c.26-.38.48-.82.73-1.23.55-1,1.07-2,1.56-3A15.26,15.26,0,0,0,674,424.2a4.91,4.91,0,0,0,4.11-.62,2.36,2.36,0,0,0,.21-3.51c-1.45-1.38-5-.67-6.55.18-.1.05-1.15.79-1.73,1.21.3-.62.59-1.24.87-1.87.8-1.83,1.54-3.71,2.3-5.58.23-.57.47-1.14.71-1.71a16.32,16.32,0,0,0,4.27,2.44,5,5,0,0,0,4.12-.63,2.36,2.36,0,0,0,.21-3.51c-1.45-1.38-5-.67-6.55.18-.12.07-1.64,1.13-2,1.42.52-1.26,1-2.5,1.62-3.71a41.24,41.24,0,0,1,2.6-4.73c.1.07,2.8,2.12,4.3,2.45a5,5,0,0,0,4.11-.62,2.37,2.37,0,0,0,.21-3.52c-1.44-1.38-5-.66-6.55.19-.12.06-1.75,1.21-2,1.43,0-.08.1-.18.16-.27a29.93,29.93,0,0,1,3.42-4.19c.69-.73,1.38-1.38,2.08-2a15.89,15.89,0,0,0,3.92,2.83,4.93,4.93,0,0,0,4.15-.17,2.37,2.37,0,0,0,.6-3.47c-1.29-1.53-4.87-1.21-6.53-.53-.09,0-1,.51-1.59.86.32-.28.64-.57,1-.83,1.16-1,2.28-1.78,3.27-2.5l1.59-1.08a15.67,15.67,0,0,0,4.77.7,5,5,0,0,0,3.61-2.06,2.38,2.38,0,0,0-1.08-3.36c-1.84-.76-4.88,1.18-6,2.54-.1.11-1.46,2.13-1.42,2.14h0c-.48.3-1,.63-1.55,1-1,.7-2.16,1.5-3.34,2.44a40.61,40.61,0,0,0-3.67,3.25,30.57,30.57,0,0,0-3.56,4.17l0,.06c.17-.56.61-2.14.63-2.26.28-1.77-.21-5.34-2-6.24a2.37,2.37,0,0,0-3.25,1.36,4.92,4.92,0,0,0,.78,4.09,16.65,16.65,0,0,0,3.71,3.23,42.91,42.91,0,0,0-2.8,4.83c-.48,1-.94,2-1.39,3,.14-.49.26-.93.27-1,.28-1.76-.21-5.33-2-6.24a2.37,2.37,0,0,0-3.24,1.36,5,5,0,0,0,.77,4.09,15.51,15.51,0,0,0,3.6,3.15l-.51,1.16c-.79,1.86-1.58,3.71-2.41,5.51-.29.63-.6,1.24-.91,1.86.12-.44.22-.8.23-.86.28-1.76-.21-5.33-2-6.24a2.37,2.37,0,0,0-3.24,1.36,5,5,0,0,0,.77,4.09,15,15,0,0,0,3.49,3.08c-.33.62-.67,1.24-1,1.82-.25.4-.46.79-.74,1.18l-.77,1.14c-.53.7-1.06,1.43-1.59,2.11-.36.47-.71.92-1.07,1.37.3-.63.86-1.87.89-2a9.19,9.19,0,0,0,.09-4.63,3.1,3.1,0,0,0,.11-.51,2.35,2.35,0,0,0-2.2-2.74c-2-.06-4.13,2.85-4.73,4.53,0,.1-.29,1.22-.44,1.93,0-.43.05-.85.07-1.29,0-.88.07-1.76.1-2.7,0-.46,0-.92,0-1.38s0-.95-.06-1.43c-.07-1.11-.2-2.23-.35-3.35a15.51,15.51,0,0,0,4.74-.34,5,5,0,0,0,3.09-2.79,2.37,2.37,0,0,0-1.76-3.05c-2-.35-4.52,2.19-5.36,3.77-.05.1-.53,1.29-.78,1.95-.09-.67-.19-1.35-.31-2-.34-2-.75-3.94-1.15-5.92-.13-.61-.24-1.21-.36-1.82a16.28,16.28,0,0,0,4.91-.33,4.91,4.91,0,0,0,3.09-2.78,2.37,2.37,0,0,0-1.77-3c-2-.36-4.51,2.19-5.35,3.76-.07.12-.75,1.85-.9,2.29-.26-1.33-.51-2.66-.69-4a41.68,41.68,0,0,1-.45-5.38c.13,0,3.51.22,4.94-.33a4.93,4.93,0,0,0,3.09-2.79,2.37,2.37,0,0,0-1.77-3.05c-2-.35-4.51,2.2-5.35,3.77-.07.12-.8,2-.91,2.32,0-.1,0-.21,0-.31a30.86,30.86,0,0,1,.54-5.39c.18-1,.4-1.91.63-2.81a15.93,15.93,0,0,0,4.84.19,4.9,4.9,0,0,0,3.37-2.43,2.37,2.37,0,0,0-1.42-3.22c-1.91-.57-4.73,1.68-5.74,3.15,0,.08-.52,1-.85,1.6.11-.4.22-.82.34-1.21.43-1.45.91-2.75,1.35-3.89.25-.65.5-1.24.73-1.78a15.91,15.91,0,0,0,4.36-2.05,5,5,0,0,0,1.87-3.71,2.35,2.35,0,0,0-2.74-2.2c-2,.37-3.43,3.67-3.64,5.44,0,.15,0,2.58,0,2.57h0c-.23.51-.48,1.07-.73,1.69-.47,1.14-1,2.43-1.44,3.88a40.82,40.82,0,0,0-1.28,4.73,31.14,31.14,0,0,0-.66,5.44v.07c-.16-.57-.66-2.13-.72-2.24-.73-1.63-3.11-4.33-5.1-4.1a2.35,2.35,0,0,0-2,2.92A4.9,4.9,0,0,0,648.38,396.14Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.9,396.85s1.28-2.06,1.34-2.2c.74-1.62,1.2-5.2-.27-6.54a2.36,2.36,0,0,0-3.49.46,4.91,4.91,0,0,0-.34,4.14C681.58,394.21,683.9,396.85,683.9,396.85Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.4,423s-5-.62-12.89,7.18C683.51,430.17,691.34,431.61,696.4,423Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699,417.17s-5-.62-12.9,7.19C686.14,424.36,694,425.79,699,417.17Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.41,408.5s-5,.74-10.5,10.37C687.91,418.87,695.84,418.16,698.41,408.5Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.64,407.49s-.46,5,7.61,12.65C687.25,420.14,688.43,412.26,679.64,407.49Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.94,431.74h0c.08-.61.81-8-7.61-12.61C676.38,419.13,675.93,424.16,683.94,431.74Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.41,414.32s-.46,5,7.6,12.65C686,427,687.19,419.09,678.41,414.32Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.52,401.77a11.12,11.12,0,0,0,3,1.27s0-1.59-.06-1.69c-.18-1.15-1.22-3.28-2.52-3.48a1.55,1.55,0,0,0-1.74,1.51A3.22,3.22,0,0,0,55.52,401.77Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.39,408.39a10.84,10.84,0,0,0,3.2.42,28.51,28.51,0,0,0,.22,3.66c.09.71.2,1.42.31,2.13-.1-.32-.19-.6-.21-.64-.48-1.06-2-2.84-3.35-2.69a1.55,1.55,0,0,0-1.28,1.92,3.28,3.28,0,0,0,1.9,2,10.48,10.48,0,0,0,3.11.42c.05.27.09.54.14.81.24,1.31.48,2.61.67,3.89q.1.68.18,1.35c-.09-.28-.17-.52-.19-.55-.48-1.07-2-2.85-3.34-2.7a1.56,1.56,0,0,0-1.29,1.92,3.26,3.26,0,0,0,1.9,2,10.11,10.11,0,0,0,3,.42c0,.46.08.92.1,1.37s0,.6,0,.91,0,.6,0,.9c0,.58-.06,1.17-.1,1.73l-.09,1.14c-.07-.45-.21-1.33-.23-1.41-.32-1.12-1.59-3.11-2.9-3.16a1.54,1.54,0,0,0-1.56,1.7,3.24,3.24,0,0,0,1.58,2.22,10.66,10.66,0,0,0,3.08.9c-.05.62-.11,1.22-.18,1.79,0,.34-.07.66-.11,1h.8l.09-.9c.06-.63.11-1.3.15-2a19.13,19.13,0,0,0,2-.3,11.14,11.14,0,0,0,2,2.35l-.68.84h1l.41-.53c.1.05.54.29,1.08.53h4.32l.21-.2a1.55,1.55,0,0,0-.22-2.3c-1.07-.75-3.29.07-4.22.77-.06.05-.61.56-.94.9.16-.23.33-.45.5-.68.35-.46.68-.93,1-1.44L67,428c.17-.25.32-.53.48-.8.36-.64.7-1.29,1-2a10.25,10.25,0,0,0,2.72,1.54,3.28,3.28,0,0,0,2.7-.41,1.56,1.56,0,0,0,.14-2.31c-1-.9-3.27-.43-4.3.12-.06,0-.76.52-1.13.79l.57-1.22c.52-1.2,1-2.43,1.51-3.66.15-.38.3-.75.46-1.12a10.84,10.84,0,0,0,2.8,1.6,3.28,3.28,0,0,0,2.7-.41,1.56,1.56,0,0,0,.14-2.31c-1-.9-3.26-.43-4.29.12-.08,0-1.08.74-1.32.93.34-.82.68-1.64,1.06-2.43a27.2,27.2,0,0,1,1.7-3.11A10.79,10.79,0,0,0,76.76,415a3.22,3.22,0,0,0,2.69-.41,1.55,1.55,0,0,0,.14-2.3c-1-.91-3.26-.44-4.29.12-.08,0-1.16.79-1.34.94l.11-.18a19.85,19.85,0,0,1,2.24-2.75c.45-.47.91-.9,1.36-1.31A10.76,10.76,0,0,0,80.25,411a3.23,3.23,0,0,0,2.72-.11,1.55,1.55,0,0,0,.39-2.28c-.84-1-3.2-.79-4.28-.35-.06,0-.63.33-1,.57a7.72,7.72,0,0,1,.62-.54c.76-.64,1.49-1.18,2.15-1.65l1-.71a10,10,0,0,0,3.12.46A3.24,3.24,0,0,0,87.34,405a1.55,1.55,0,0,0-.7-2.2c-1.21-.5-3.2.77-4,1.66-.07.08-1,1.4-.93,1.41h0l-1,.66c-.67.46-1.42,1-2.19,1.6a26.7,26.7,0,0,0-2.41,2.13A19.75,19.75,0,0,0,73.83,413l0,0c.12-.37.41-1.41.42-1.49.18-1.15-.14-3.5-1.31-4.09a1.55,1.55,0,0,0-2.13.89,3.25,3.25,0,0,0,.51,2.68,11.07,11.07,0,0,0,2.44,2.13,27.1,27.1,0,0,0-1.84,3.17c-.32.63-.62,1.28-.91,1.94.09-.32.17-.61.17-.65.19-1.15-.14-3.49-1.31-4.09a1.54,1.54,0,0,0-2.12.89,3.24,3.24,0,0,0,.5,2.69,10.34,10.34,0,0,0,2.36,2.06l-.33.76c-.52,1.22-1,2.44-1.58,3.61-.19.42-.4.82-.6,1.22.08-.28.14-.52.15-.56.18-1.15-.14-3.5-1.31-4.09a1.55,1.55,0,0,0-2.13.89,3.25,3.25,0,0,0,.51,2.68,10,10,0,0,0,2.29,2c-.22.41-.44.82-.67,1.2s-.3.52-.48.77-.35.5-.51.75c-.35.46-.7.94-1,1.38s-.47.61-.7.9c.19-.41.56-1.22.58-1.29a6,6,0,0,0,0-3,1.3,1.3,0,0,0,.08-.34,1.55,1.55,0,0,0-1.45-1.8c-1.31,0-2.71,1.87-3.09,3,0,.06-.2.8-.3,1.26,0-.28,0-.56.05-.85,0-.57,0-1.15.07-1.76,0-.3,0-.61,0-.91s0-.62,0-.94c0-.72-.13-1.46-.23-2.2a9.92,9.92,0,0,0,3.11-.22,3.24,3.24,0,0,0,2-1.83,1.56,1.56,0,0,0-1.16-2c-1.29-.23-3,1.44-3.51,2.47,0,.07-.35.85-.51,1.29-.07-.45-.13-.89-.21-1.34-.22-1.29-.49-2.59-.75-3.88-.09-.4-.16-.8-.24-1.19a10.94,10.94,0,0,0,3.22-.22,3.24,3.24,0,0,0,2-1.83,1.56,1.56,0,0,0-1.16-2c-1.29-.23-3,1.44-3.51,2.47,0,.08-.49,1.21-.59,1.5-.17-.87-.33-1.74-.46-2.61a28.62,28.62,0,0,1-.29-3.53,10.55,10.55,0,0,0,3.24-.22,3.24,3.24,0,0,0,2-1.83,1.55,1.55,0,0,0-1.16-2c-1.29-.24-3,1.43-3.51,2.47-.05.08-.53,1.29-.6,1.52,0-.07,0-.14,0-.21a19.92,19.92,0,0,1,.35-3.53c.12-.65.26-1.26.42-1.85a10.14,10.14,0,0,0,3.17.13A3.25,3.25,0,0,0,64,401.79a1.55,1.55,0,0,0-.93-2.11c-1.26-.38-3.1,1.1-3.76,2.06,0,.06-.35.63-.56,1.05.07-.26.14-.54.22-.79.28-.95.6-1.8.88-2.56.17-.42.33-.81.48-1.16a10.55,10.55,0,0,0,2.86-1.34,3.26,3.26,0,0,0,1.23-2.44,1.56,1.56,0,0,0-1.8-1.45c-1.29.25-2.25,2.41-2.39,3.57,0,.1,0,1.7,0,1.69h0c-.16.34-.32.71-.49,1.11-.3.75-.64,1.6-.94,2.54a28.45,28.45,0,0,0-.84,3.11,21.14,21.14,0,0,0-.43,3.57v0c-.11-.37-.44-1.39-.47-1.46-.48-1.07-2-2.85-3.35-2.7a1.55,1.55,0,0,0-1.28,1.92A3.26,3.26,0,0,0,54.39,408.39Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.69,408.85s.84-1.35.88-1.44c.48-1.07.79-3.41-.18-4.29a1.55,1.55,0,0,0-2.29.3,3.23,3.23,0,0,0-.22,2.72A11.15,11.15,0,0,0,77.69,408.85Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.89,426s-3.3-.41-8.46,4.71C77.43,430.71,82.57,431.66,85.89,426Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.62,422.18s-3.3-.41-8.46,4.72C79.16,426.9,84.3,427.84,87.62,422.18Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.21,416.5s-3.29.48-6.89,6.8C80.32,423.3,85.52,422.83,87.21,416.5Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.89,415.83s-.3,3.31,5,8.3C79.88,424.13,80.66,419,74.89,415.83Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.71,431.74h0c0-.4.53-5.27-5-8.27C72.75,423.47,72.46,426.76,77.71,431.74Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.09,420.31s-.3,3.31,5,8.3C79.07,428.61,79.85,423.44,74.09,420.31Z",
    style: {
      fill: "#1D50FF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.17,70.7c-.74-1.83-1-4.13-1.63-5.79a61.12,61.12,0,0,0-4.3-9.16C363.76,44.47,353,34.13,339.47,33,312.84,30.64,308.21,50.32,305.89,59s-8.1-4.63-17.95-2.32-8.1,16.79-13.89,20.84-16.21-6.94-22-2.89-4.06,11-7,12.16-5.21-7.53-11-2.9a16,16,0,0,0-5.79,11.58H416.39s9.35-19.68-8-24.31c-6-1.61-12.22-1-18.2.45-3.67.9-9.58,4.36-12.84,1A5.9,5.9,0,0,1,376.17,70.7Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.52,128c-.44-1.09-.6-2.45-1-3.43a37.31,37.31,0,0,0-2.55-5.43c-3.84-6.68-10.2-12.8-18.22-13.49C532,104.24,529.28,115.9,527.91,121s-4.8-2.74-10.63-1.37-4.8,9.94-8.23,12.34-9.6-4.11-13-1.71-2.4,6.51-4.12,7.2-3.08-4.46-6.51-1.72a9.49,9.49,0,0,0-3.43,6.86H593.33s5.54-11.66-4.75-14.4a21.72,21.72,0,0,0-10.77.27c-2.18.53-5.68,2.58-7.61.57A3.45,3.45,0,0,1,569.52,128Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.54,148.46c-.36-.89-.49-2-.79-2.79a28.84,28.84,0,0,0-2.08-4.43c-3.12-5.45-8.32-10.44-14.86-11-12.86-1.12-15.1,8.39-16.22,12.58s-3.91-2.23-8.66-1.12-3.92,8.11-6.71,10.07-7.83-3.36-10.63-1.4-2,5.32-3.36,5.87-2.51-3.63-5.31-1.39a7.74,7.74,0,0,0-2.79,5.59H173s4.52-9.51-3.87-11.75a17.69,17.69,0,0,0-8.79.23c-1.78.43-4.63,2.1-6.21.46A3,3,0,0,1,153.54,148.46Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trees--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M641.78,226.65s30.5-15.25,55.28,8.58c.33.32.66.61,1,.92A86.51,86.51,0,0,0,731.37,168c0-48.16-39.68-87.2-88.63-87.2s-88.63,39-88.63,87.2a86.52,86.52,0,0,0,33.5,68.26C593.16,232.21,619,214.82,641.78,226.65Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.78,226.65s30.5-15.25,55.28,8.58c.33.32.66.61,1,.92A86.51,86.51,0,0,0,731.37,168c0-48.16-39.68-87.2-88.63-87.2s-88.63,39-88.63,87.2a86.52,86.52,0,0,0,33.5,68.26C593.16,232.21,619,214.82,641.78,226.65Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.17 208.03 640.29 217.79 638.88 431.64 646.12 431.64 644.53 204.29 667.07 191.77 699.36 195.41 670.44 189.89 705.94 170.17 684.18 180.81 687.45 170.49 702.1 158.92 688.39 167.53 692.5 154.53 682.89 177.68 674.83 167.94 679.33 152.88 673.44 166.26 663.96 154.81 681.71 180.51 680.93 182.4 644.43 200.25 643.55 165.78 654.44 153.2 686.46 144.93 673.46 147.17 679.6 140.26 671 147.6 657.24 149.97 673.01 131.76 660.5 143.82 661.49 128.46 658.53 145.71 643.4 160.29 642.74 134.21 642.28 149.86 636.83 140.61 638.9 129.41 650.51 118.31 639.5 126.18 642.83 108.16 635.07 137.61 627.74 125.17 632.74 135.17 620.06 131.21 634.15 137.99 642.16 154 641.41 179.38 624.58 166.4 620.39 156 622.25 140.54 618.96 152.34 619.2 153.06 611.83 134.77 622.2 164.56 606.34 152.34 626.34 170.39 596.19 168.52 612.7 170.88 592.35 176.48 616.85 171.48 629.54 173.29 641.28 183.89 640.43 212.81 620.67 208.4 601.95 185.26 611.88 199.27 588.78 193.49 614.55 203.03 617.93 207.79 595.64 202.82 607.35 206.75 584.11 212.15 611.17 208.03",
    style: {
      fill: "#919191"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.75,288.1s21.36-10.68,38.71,6l.7.65a60.58,60.58,0,0,0,23.32-47.69c0-33.73-27.78-61.06-62.06-61.06s-62.06,27.33-62.06,61.06a60.56,60.56,0,0,0,23.46,47.79C50.7,292,68.77,279.81,84.75,288.1Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.75,288.1s21.36-10.68,38.71,6l.7.65a60.58,60.58,0,0,0,23.32-47.69c0-33.73-27.78-61.06-62.06-61.06s-62.06,27.33-62.06,61.06a60.56,60.56,0,0,0,23.46,47.79C50.7,292,68.77,279.81,84.75,288.1Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.31 275.06 83.71 281.89 82.72 431.64 87.79 431.64 86.68 272.44 102.46 263.67 125.07 266.22 104.82 262.36 129.68 248.55 114.44 256 116.73 248.77 126.99 240.67 117.39 246.69 120.27 237.59 113.54 253.8 107.9 246.99 111.04 236.44 106.92 245.81 100.28 237.79 112.72 255.79 112.16 257.11 86.61 269.61 85.99 245.47 93.62 236.66 116.04 230.87 106.93 232.44 111.23 227.6 105.21 232.74 95.57 234.41 106.62 221.65 97.86 230.09 98.55 219.34 96.48 231.42 85.89 241.63 85.42 223.37 85.1 234.32 81.29 227.85 82.74 220 90.87 212.23 83.16 217.74 85.49 205.12 80.05 225.75 74.92 217.04 78.42 224.04 69.54 221.26 79.41 226.02 85.02 237.23 84.5 254.99 72.71 245.91 69.77 238.62 71.08 227.8 68.77 236.06 68.94 236.57 63.78 223.76 71.04 244.62 59.93 236.06 73.94 248.7 52.83 247.4 64.39 249.05 50.13 252.97 67.29 249.46 76.18 250.73 84.4 258.15 83.81 278.4 69.97 275.32 56.86 259.12 63.82 268.92 47.64 264.88 65.69 271.56 68.05 274.89 52.44 271.41 60.64 274.16 44.37 277.94 63.31 275.06",
    style: {
      fill: "#919191"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--drive-thru--inject-39"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 228.72,
    width: 100.44,
    height: 202.92,
    transform: "translate(1154.44 660.35) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 228.72,
    width: 100.44,
    height: 35.38,
    transform: "translate(1154.44 492.81) rotate(180)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 348.85,
    width: 100.44,
    height: 82.78,
    transform: "translate(1154.44 780.49) rotate(180)",
    style: {
      fill: "#9c9c9c",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.6,
    y: 228.96,
    width: 356.4,
    height: 202.92,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.6,
    y: 228.96,
    width: 356.4,
    height: 34.94,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.6,
    y: 349.09,
    width: 356.4,
    height: 82.79,
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.35,
    y: 359.12,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.75,
    y: 359.12,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.46,
    y: 359.12,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476.55,
    y: 365.01,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490.22,
    y: 376.78,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.61,
    y: 418.83,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.37,
    y: 419.25,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483.28,
    y: 397.81,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.68,
    y: 397.81,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 491.48,
    y: 403.7,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.38,
    y: 397.81,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.78,
    y: 397.81,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.58,
    y: 403.7,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483.28,
    y: 385.19,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.68,
    y: 385.19,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 491.48,
    y: 391.08,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.31,
    y: 359.12,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#7a7a7a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 574.71,
    y: 359.12,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#7a7a7a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 597.42,
    y: 359.12,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#7a7a7a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 566.51,
    y: 365.01,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#7a7a7a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 580.18,
    y: 376.78,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#7a7a7a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 563.57,
    y: 418.83,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#7a7a7a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.26,
    y: 419.25,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#7a7a7a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 573.24,
    y: 397.81,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#7a7a7a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.64,
    y: 397.81,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#7a7a7a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.44,
    y: 403.7,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#7a7a7a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 538.34,
    y: 397.81,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#7a7a7a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554.74,
    y: 397.81,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#7a7a7a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.54,
    y: 403.7,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#7a7a7a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 573.24,
    y: 385.19,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#7a7a7a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.64,
    y: 385.19,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#7a7a7a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.44,
    y: 391.08,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#7a7a7a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.01,
    y: 359.12,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.41,
    y: 359.12,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.11,
    y: 359.12,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.21,
    y: 365.01,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.87,
    y: 376.78,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.68,
    y: 376.78,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.26,
    y: 418.83,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.95,
    y: 419.25,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.09,
    y: 419.25,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.05,
    y: 376.78,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.75,
    y: 376.78,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.57,
    y: 376.78,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.16,
    y: 370.48,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.93,
    y: 397.81,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.33,
    y: 397.81,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.13,
    y: 403.7,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.45,
    y: 397.81,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.85,
    y: 397.81,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.65,
    y: 403.7,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.03,
    y: 397.81,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.43,
    y: 397.81,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.23,
    y: 403.7,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.93,
    y: 385.19,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.33,
    y: 385.19,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.13,
    y: 391.08,
    width: 13.88,
    height: 4.2,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "652.81 255.82 228.54 255.82 249.81 232.52 631.53 232.52 652.81 255.82",
    style: {
      fill: "#9c9c9c",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.52,
    y: 251.19,
    width: 426.42,
    height: 4.63,
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "631.71 232.52 251.22 232.52 279.76 172.53 603.17 172.53 631.71 232.52",
    style: {
      fill: "#9c9c9c",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "514.21 232.52 157.28 232.52 184.05 172.53 487.44 172.53 514.21 232.52",
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "535.32 255.82 137.33 255.82 157.28 232.52 515.37 232.52 535.32 255.82",
    style: {
      fill: "#d1d1d1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.31,
    y: 251.19,
    width: 400.02,
    height: 4.63,
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.5,
    y: 269.94,
    width: 115.4,
    height: 97.47,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.93,
    y: 273.68,
    width: 106.53,
    height: 89.98,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.93,
    y: 273.68,
    width: 51.18,
    height: 89.98,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.24,
    y1: 349.17,
    x2: 290.49,
    y2: 351.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.94,
    y1: 328.47,
    x2: 296.25,
    y2: 346.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 323.41,
    y1: 325.32,
    x2: 307.62,
    y2: 341.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.99 319.71 252.45 319.71 281.93 273.68 388.46 273.68 358.99 319.71",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.38 319.8 388.38 273.81 358.99 319.71 359.61 319.8 388.38 319.8",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.8,155.36h137a7.36,7.36,0,0,1,7.36,7.36v88.42a0,0,0,0,1,0,0H257.44a0,0,0,0,1,0,0V162.72A7.36,7.36,0,0,1,264.8,155.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.33,198.56V161.89h8a14,14,0,0,1,6.45,1.25,7.12,7.12,0,0,1,3.4,3.73,16.67,16.67,0,0,1,1,6.21v13.49a18.73,18.73,0,0,1-1,6.56,7.86,7.86,0,0,1-3.31,4.05,11.79,11.79,0,0,1-6.13,1.38Zm5.12-3.66h2.9a5.85,5.85,0,0,0,4-1.09,4.94,4.94,0,0,0,1.42-3.17,42.24,42.24,0,0,0,.25-5V173.71a24,24,0,0,0-.36-4.62,3.91,3.91,0,0,0-1.58-2.58,7.14,7.14,0,0,0-3.85-.81h-2.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.19,198.56V161.89h7.38a16.21,16.21,0,0,1,6.06,1,6.8,6.8,0,0,1,3.56,3.12,11.92,11.92,0,0,1,1.15,5.64,15.46,15.46,0,0,1-.45,3.87,7.51,7.51,0,0,1-1.45,2.94,5.6,5.6,0,0,1-2.63,1.74L312,198.56h-4.93l-4.8-17.2h-4v17.2Zm5.11-20.87h1.95a9.66,9.66,0,0,0,3.53-.54,3.6,3.6,0,0,0,2-1.86,8.43,8.43,0,0,0,.64-3.66,7.3,7.3,0,0,0-1.18-4.64q-1.19-1.43-4.66-1.43H298.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,198.56V161.89h5v36.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.29,198.56l-8.19-36.67h4.8l5.79,27,5.52-27h4.67l-8.11,36.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.77,198.56V161.89H365v3.81h-9.1v12.13h7.38v3.62h-7.38V194.9h9.19v3.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.39,241.43V206.15h-6.66v-4.08h18.61v4.08h-6.46v35.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.13,241.43V202.07h5.49v17h10.11v-17h5.49v39.36h-5.49V223H332.62v18.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.39,241.43V202.07h7.92a17.54,17.54,0,0,1,6.51,1,7.31,7.31,0,0,1,3.82,3.36,12.84,12.84,0,0,1,1.24,6.05,16.69,16.69,0,0,1-.49,4.15,8,8,0,0,1-1.55,3.16A6.13,6.13,0,0,1,369,221.7l5.59,19.73h-5.3L364.16,223h-4.28v18.47Zm5.49-22.4H362a10.28,10.28,0,0,0,3.79-.59,3.87,3.87,0,0,0,2.14-2,9.28,9.28,0,0,0,.68-3.93q0-3.45-1.26-5c-.85-1-2.51-1.53-5-1.53h-2.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.77,241.87a10.87,10.87,0,0,1-6.56-1.7,8.46,8.46,0,0,1-3.11-4.79,28.11,28.11,0,0,1-.83-7.22V202.07h5.25v26.34a28.4,28.4,0,0,0,.34,4.61,6.08,6.08,0,0,0,1.48,3.31,5.49,5.49,0,0,0,6.88,0,6.21,6.21,0,0,0,1.45-3.31,28.4,28.4,0,0,0,.34-4.61V202.07h5.2v26.09a28.14,28.14,0,0,1-.82,7.22,8.53,8.53,0,0,1-3.09,4.79Q394.05,241.87,389.77,241.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.17,229.52v-1.77l4.8-7.49c.36-.56.69-1.08,1-1.57a7.41,7.41,0,0,0,.75-1.52,5.59,5.59,0,0,0,.29-1.86,4.2,4.2,0,0,0-.42-2.05,1.54,1.54,0,0,0-1.47-.75,1.86,1.86,0,0,0-1.37.49,2.6,2.6,0,0,0-.68,1.28,7.17,7.17,0,0,0-.19,1.71v.63h-2.49V216a8.45,8.45,0,0,1,.45-2.92,3.75,3.75,0,0,1,1.47-1.9,4.74,4.74,0,0,1,2.7-.68,4.27,4.27,0,0,1,3.4,1.29,5.31,5.31,0,0,1,1.12,3.59,6.84,6.84,0,0,1-.29,2.12,8.39,8.39,0,0,1-.76,1.7c-.31.53-.65,1.07-1,1.63l-4.33,6.63h6v2.1Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.78,229.52v-5.06H282.3v-2.62l4.92-11.22h2.94v11.62h2.12v2.22h-2.12v5.06Zm-3.08-7.28h3.08v-8.59Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.9,239V232.2h1v3h1.76v-3h.95V239h-.95v-3.2h-1.76V239Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.39,239.12a2,2,0,0,1-1.1-.27,1.48,1.48,0,0,1-.6-.78,3.72,3.72,0,0,1-.17-1.18V234.3a3.33,3.33,0,0,1,.18-1.16,1.46,1.46,0,0,1,.59-.74,2,2,0,0,1,1.1-.26,2.06,2.06,0,0,1,1.1.26,1.46,1.46,0,0,1,.59.74,3.33,3.33,0,0,1,.18,1.16v2.6a3.43,3.43,0,0,1-.18,1.17,1.53,1.53,0,0,1-.59.77A1.89,1.89,0,0,1,277.39,239.12Zm0-.76a.94.94,0,0,0,.58-.15.81.81,0,0,0,.26-.44,3.18,3.18,0,0,0,.07-.66v-3a3,3,0,0,0-.07-.66A.76.76,0,0,0,278,233a.94.94,0,0,0-.58-.15,1,1,0,0,0-.58.15.71.71,0,0,0-.26.42,2.52,2.52,0,0,0-.07.66v3a2.62,2.62,0,0,0,.07.66.76.76,0,0,0,.26.44A1,1,0,0,0,277.39,238.36Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,239.12a1.89,1.89,0,0,1-1.14-.3,1.52,1.52,0,0,1-.54-.83,5.21,5.21,0,0,1-.14-1.26V232.2h.91v4.58a4.92,4.92,0,0,0,.06.8,1.08,1.08,0,0,0,.26.57.77.77,0,0,0,.59.21.78.78,0,0,0,.6-.21,1.08,1.08,0,0,0,.26-.57,4.92,4.92,0,0,0,.06-.8V232.2h.9v4.53a5.21,5.21,0,0,1-.14,1.26,1.52,1.52,0,0,1-.54.83A1.84,1.84,0,0,1,282,239.12Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.79,239V232.2h1.37a3.1,3.1,0,0,1,1.14.18,1.29,1.29,0,0,1,.66.58,2.28,2.28,0,0,1,.21,1,2.77,2.77,0,0,1-.08.73,1.57,1.57,0,0,1-.27.55,1.2,1.2,0,0,1-.49.32l1,3.43h-.92l-.9-3.21h-.74V239Zm.95-3.89h.36a1.75,1.75,0,0,0,.66-.11.62.62,0,0,0,.37-.34,1.61,1.61,0,0,0,.12-.69,1.31,1.31,0,0,0-.22-.86,1.07,1.07,0,0,0-.87-.27h-.42Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.78,239.12a1.76,1.76,0,0,1-1-.26,1.64,1.64,0,0,1-.6-.7,3,3,0,0,1-.23-1l.84-.23a4,4,0,0,0,.12.71,1.21,1.21,0,0,0,.29.55.88.88,0,0,0,1.13,0,.9.9,0,0,0,.19-.6,1.17,1.17,0,0,0-.22-.75,4.48,4.48,0,0,0-.53-.57l-1.15-1a1.86,1.86,0,0,1-.49-.65,2,2,0,0,1-.17-.86,1.55,1.55,0,0,1,.44-1.17,1.62,1.62,0,0,1,1.17-.41,2.17,2.17,0,0,1,.71.1,1.22,1.22,0,0,1,.52.33,1.58,1.58,0,0,1,.33.55,3.35,3.35,0,0,1,.16.78l-.81.22a3,3,0,0,0-.1-.62.86.86,0,0,0-.27-.45.73.73,0,0,0-.54-.18.78.78,0,0,0-.55.19.73.73,0,0,0-.2.56,1.12,1.12,0,0,0,.1.52,1.42,1.42,0,0,0,.35.41l1.15,1a3.59,3.59,0,0,1,.69.8,2.15,2.15,0,0,1,.29,1.12,1.72,1.72,0,0,1-.21.87,1.36,1.36,0,0,1-.58.56A1.78,1.78,0,0,1,290.78,239.12Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.63,148.13c-3.54-1.38-9.05-1.78-15.06-.86-5.79.89-10.76,2.81-13.77,5.06l-3.73.55,9.8,38.13c.49,3.21,7.19,4.84,15,3.65s13.68-4.76,13.19-8l-2-39.05Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.21,171.18,403.36,155c-.84,1.87-1.83,3.87-3,5.93A77.46,77.46,0,0,1,376,187.61l.88,3.4c.23,1.54,1.91,2.72,4.45,3.39A87.34,87.34,0,0,0,404.21,171.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.86,147.23l-.29,0a37,37,0,0,0-11,3.36,59.45,59.45,0,0,1-5.08,7.74l2.59,10.12C377.61,161.89,382,153.82,384.86,147.23Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,186.69l-.39-7.48A66.39,66.39,0,0,1,386.82,195a32.75,32.75,0,0,0,5-.38C399.61,193.46,405.51,189.9,405,186.69Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.18,154.09c.92-2.32,1.68-4.55,2.31-6.62a31.4,31.4,0,0,0-8.87-.63c-2.67,8-7.54,18.2-16.31,26.42l2.4,9.34A68.81,68.81,0,0,0,395.18,154.09Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.63,148.13c-3.54-1.38-9.05-1.78-15.06-.86-5.79.89-10.76,2.81-13.77,5.06l-3.73.55,9.8,38.13c.49,3.21,7.19,4.84,15,3.65s13.68-4.76,13.19-8l-2-39.05Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,141.44c-3.87-1.5-9.89-1.94-16.46-.94-6.33,1-11.76,3.07-15,5.54l-4.08.59.77,5c.68,4.46,10,6.73,20.84,5.07s19.05-6.62,18.36-11.08l-.71-4.67Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 384.05,
    cy: 143.91,
    rx: 19.83,
    ry: 8.17,
    transform: "translate(-17.38 59.89) rotate(-8.72)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.49,146.3c.54,3.54,7.95,5.35,16.55,4s15.12-5.26,14.58-8.8-8-5.35-16.55-4S367.94,142.76,368.49,146.3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.18,138.24c-8.29,1.27-14.66,5-14.61,8.43,1,3.3,8.17,4.93,16.47,3.66s14.66-5,14.61-8.43C398.66,138.6,391.48,137,383.18,138.24Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.22,143.39a1.45,1.45,0,0,1-.71-.06,1.5,1.5,0,0,1-.94-1.91L394,122.59a1.51,1.51,0,0,1,.71-.84l7.89-4.25a1.5,1.5,0,0,1,1.52,0l9.46,6a1.5,1.5,0,0,1-1.6,2.54l-8.72-5.49-6.61,3.55-6.22,18.28A1.5,1.5,0,0,1,389.22,143.39Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 394.56,
    y1: 122.21,
    x2: 396.64,
    y2: 124.11,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 396.32,
    y1: 121.01,
    x2: 398.14,
    y2: 123.29,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 398.12,
    y1: 120.11,
    x2: 399.81,
    y2: 122.49,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 399.5,
    y1: 118.97,
    x2: 401.14,
    y2: 121.51,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 401.12,
    y1: 118.41,
    x2: 402.52,
    y2: 120.91,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.25,
    y1: 120.56,
    x2: 402.59,
    y2: 117.5,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Menu--inject-39"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.03,
    y: 288.56,
    width: 63.72,
    height: 143.32,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.16,
    y: 297.54,
    width: 51.41,
    height: 84.27,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.16,313.69l.2-10.82h1.48l1.91,8.78,1.92-8.78h1.47l.2,10.82h-1.21l-.12-7.85-1.83,7.85h-.86l-1.81-7.85-.12,7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,313.69V302.87h4.19V304h-2.68v3.58h2.17v1.07h-2.17v4h2.71v1.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.43,313.69V302.87h1l3.07,7.19v-7.19h1.26v10.82h-1l-3.11-7.39v7.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.28,313.81a3,3,0,0,1-1.81-.47,2.36,2.36,0,0,1-.85-1.31,7.83,7.83,0,0,1-.23-2v-7.17h1.45v7.24a8.24,8.24,0,0,0,.09,1.27,1.71,1.71,0,0,0,.41.91,1.24,1.24,0,0,0,.94.33,1.26,1.26,0,0,0,.95-.33,1.86,1.86,0,0,0,.4-.91,8.24,8.24,0,0,0,.09-1.27v-7.24h1.43V310a7.83,7.83,0,0,1-.23,2,2.31,2.31,0,0,1-.85,1.31A2.94,2.94,0,0,1,146.28,313.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.65,
    y1: 321.97,
    x2: 133.32,
    y2: 321.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.65,
    y1: 328.21,
    x2: 133.32,
    y2: 328.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.65,
    y1: 334.45,
    x2: 133.32,
    y2: 334.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.65,
    y1: 340.69,
    x2: 133.32,
    y2: 340.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.65,
    y1: 346.93,
    x2: 133.32,
    y2: 346.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.65,
    y1: 353.18,
    x2: 133.32,
    y2: 353.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.65,
    y1: 359.42,
    x2: 133.32,
    y2: 359.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.65,
    y1: 365.66,
    x2: 133.32,
    y2: 365.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.27,
    y1: 321.97,
    x2: 156.94,
    y2: 321.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.27,
    y1: 328.21,
    x2: 156.94,
    y2: 328.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.27,
    y1: 334.45,
    x2: 156.94,
    y2: 334.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.27,
    y1: 340.69,
    x2: 156.94,
    y2: 340.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.27,
    y1: 346.93,
    x2: 156.94,
    y2: 346.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.27,
    y1: 353.18,
    x2: 156.94,
    y2: 353.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.27,
    y1: 359.42,
    x2: 156.94,
    y2: 359.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.27,
    y1: 365.66,
    x2: 156.94,
    y2: 365.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Car--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M530.52,393.06h-6.83l-.1.15a11.53,11.53,0,0,0-1.77-.15c-8.33,0-15.08,8.69-15.08,19.41s6.75,19.41,15.08,19.41a12.94,12.94,0,0,0,1.77-.14l.1.14h6.83c8.33,0,15.08-8.69,15.08-19.41S538.85,393.06,530.52,393.06Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.56,393.06h-6.84l-.1.15a11.4,11.4,0,0,0-1.76-.15c-8.33,0-15.09,8.69-15.09,19.41s6.76,19.41,15.09,19.41a12.79,12.79,0,0,0,1.76-.14l.1.14h6.84c8.33,0,15.08-8.69,15.08-19.41S398.89,393.06,390.56,393.06Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.54,393.63h-3.28L589.33,373a5.09,5.09,0,0,0-5-4.37H565.91L536.07,337a17.08,17.08,0,0,0-12.44-5.37H444.52a12.62,12.62,0,0,0-9.13,3.89L299.52,392.88V417.1H503.23l51.12-.36,37.91-2.49v-.17h3.12a1.25,1.25,0,0,0,1.25-1.25V394.72A1.09,1.09,0,0,0,595.54,393.63Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.67,413.38v3.48l16.68-.12,37.91-2.49v-.17h3.12a1.25,1.25,0,0,0,1.11-.7Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.35,416.74h0a1.25,1.25,0,0,0-.08-2.49H535.1l-70.89-82.62H444.52a12.62,12.62,0,0,0-9.13,3.89L299.52,392.88V417.1H503.23Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.26,393.06h-6.84l-4.48,6.58a23.72,23.72,0,0,0,0,25.66l4.48,6.58h6.84c8.33,0,15.08-8.69,15.08-19.41S339.59,393.06,331.26,393.06Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 322.56,
    cy: 412.47,
    rx: 15.09,
    ry: 19.41,
    style: {
      fill: "#636363",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 322.56,
    cy: 412.47,
    rx: 12.03,
    ry: 15.48,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 322.56,
    cy: 412.47,
    rx: 2.54,
    ry: 3.27,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.51,393.06h-6.84l-4.48,6.58a23.72,23.72,0,0,0,0,25.66l4.48,6.58h6.84c8.33,0,15.08-8.69,15.08-19.41S491.84,393.06,483.51,393.06Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 474.81,
    cy: 412.47,
    rx: 15.09,
    ry: 19.41,
    style: {
      fill: "#636363",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 474.81,
    cy: 412.47,
    rx: 12.03,
    ry: 15.48,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 474.81,
    cy: 412.47,
    rx: 2.54,
    ry: 3.27,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.07,337c-.25-.26-.51-.5-.77-.74H473.67v30.45h90.39Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.15,393.63h-3.59l-3.57-25H513.2L483.36,337a17.08,17.08,0,0,0-12.44-5.37H398.3a12.66,12.66,0,0,0-9.13,3.89l-46.38,31-42.92,18.52-6.71,9a12.85,12.85,0,0,0-2.55,7.67V417.1h13.54V412c0-12.51,9.1-22.66,20.32-22.66h0c10,0,16.22,8.11,17.78,19.13l1.23,8.65H456.57V412c0-12.51,5.14-22.66,18.94-22.66h0c12.3,0,16.7,8.11,18.62,19.13l1.44,8.29,44-2.49v-.17h3.59Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.56,340.09l-39.83,26.44h74.44V336.61H397.81A11.54,11.54,0,0,0,389.56,340.09Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.91,366.53l23.61-29.92h-6.71a11.54,11.54,0,0,0-8.25,3.48l-13.94,9.25-13.56,17.19Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.17 366.53 424.17 345.05 407.21 366.53 424.17 366.53",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.88,341.49l16.93,17.31a4.57,4.57,0,0,1,1.16,2.08h0a4.54,4.54,0,0,1-4.41,5.65H429.15V336.61H469.3A16.19,16.19,0,0,1,480.88,341.49Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "465.02 336.61 458.44 336.61 434.83 366.53 441.41 366.53 465.02 336.61",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.15 338.73 429.15 362.62 449.67 336.61 430.82 336.61 429.15 338.73",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536,368.67h48.3a5.09,5.09,0,0,1,5,4.37l2.93,20.59h-52.7Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.93,
    y: 379.92,
    width: 22.9,
    height: 9.41,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 594.78,
    y1: 397.48,
    x2: 496.64,
    y2: 397.48,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 452.79,
    y1: 397.48,
    x2: 344.03,
    y2: 397.48,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.92,
    y1: 397.48,
    x2: 295.47,
    y2: 397.48,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555,380.08H533.34a5.38,5.38,0,0,0-4.82,3l-3.62,7.23a2.18,2.18,0,0,0,2,3.16H555Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "554.98 380.08 537.54 380.08 539.45 393.44 554.98 393.44 554.98 380.08",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "590.25 380.08 584.97 380.08 584.9 393.44 592.16 393.44 590.25 380.08",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.25,
    y: 360.3,
    width: 13.89,
    height: 11.75,
    rx: 2,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.03,
    y: 372.05,
    width: 13.36,
    height: 5.34,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.59,
    y1: 369.91,
    x2: 425.59,
    y2: 410.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.31,388.08s9.78,5.52,11,24.39H450.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.31,396.09s-5.11-13.36-22.24-13.36c-11.93,0-17.64,6.27-20.5,11.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-39"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 36.14,
    y1: 431.64,
    x2: 705.71,
    y2: 431.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounter);
export default __webpack_public_path__ + "static/media/counter.1faf7d8c5d60cd6490ebf63dd8856dbc.svg";
export { ForwardRef as ReactComponent };